import { GA } from "./IReactGA.analytics";

export const setupReactGA = () => {
  const tag = process.env.REACT_APP_GOOGLE_ANALYTICS_TAG?.trim();
  if (!tag || GA.isInitialized) return;
  try {
    GA.initialize(tag);
    GA.set({ anonymizeIp: true });
  } catch {
    // GA is optional — never crash the app over a missing/invalid measurement ID
  }
};
